module.exports = __webpack_public_path__ + "img/separator2.60a3c04d.svg";